import { Table } from "../../../../../_helpers/Table";
import { useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import {
    getBadgeusesEstablishments,
    deleteBadgeuse,
} from "../../../../../_api/Badgeuse";
import { SideBar } from "../../../../../_helpers/components/SideBar";
import { ListElement } from "../../../../../_helpers/components/ListElement";
import { InputForm } from "../../../../../_helpers/components/Forms/InputLabel";
import { DefaultDropdown } from "../../../../../_helpers/components/Forms/Dropdown";
import { Button } from "../../../../../_helpers/components/Button";
import { editBadgeuse } from "../../../../../_api/Badgeuse";
import toast from "react-hot-toast";

const BadgeusesForm = (props) => {
    const { badgeuse, closeModal, refreshData } = props;

    const badgeuseOptions = [
        { label: "Physique", value: "PHYSICAL" },
        { label: "Internet", value: "WEB" },
        { label: "Mobile", value: "MOBILE" },
    ];

    const [name, setName] = useState(badgeuse.name);
    const [remarks, setRemarks] = useState(badgeuse?.remarks ?? "");
    const [type, setType] = useState(
        badgeuseOptions.find((option) => option.value === badgeuse.type).value
    );
    const [created_at, setCreatedAt] = useState(
        new Date(badgeuse.created_at).toISOString().split("T")[0]
    );
    const [isSaving, setIsSaving] = useState(false);

    const _edit = () => {
        const payload = {
            name,
            remarks,
            type: type,
        };
        setIsSaving(true);
        editBadgeuse(badgeuse.id, payload)
            .then((resp) => {
                toast(resp.data.message);
                closeModal();
                refreshData();
            })
            .catch((resp) => {
                toast.error(resp.response.data.message);
            })
            .finally(() => setIsSaving(false));
    };

    const _delete = () => {
        deleteBadgeuse(badgeuse.id).then((resp) => {
            toast(resp.data.message);
            closeModal();
            refreshData();
        });
    };

    return (
        <>
            <div className="flex flex-wrap -mx-2">
                <div className="w-full md:w-1/2  px-2 mb-3">
                    <InputForm
                        name="Nom"
                        value={name}
                        placeholder="Nom"
                        type="text"
                        set={setName}
                        required={true}
                    />
                </div>
                <div className="w-full md:w-1/2  px-2 mb-3">
                    <DefaultDropdown
                        name={"Type"}
                        required={true}
                        options={[
                            { label: "Physique", value: "PHYSICAL" },
                            { label: "Internet", value: "WEB" },
                            { label: "Mobile", value: "MOBILE" },
                        ]}
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                    />
                </div>
                <div className="w-full md:w-1/2  px-2 mb-3">
                    <InputForm
                        name="Date de création"
                        value={created_at}
                        readOnly={true}
                        placeholder="..."
                        type="date"
                        set={setCreatedAt}
                        required={false}
                    />
                </div>
                <div className="w-full px-2 mb-3">
                    <InputForm
                        name="Notes"
                        value={remarks}
                        placeholder="..."
                        type="textarea"
                        set={setRemarks}
                        required={false}
                    />
                </div>
            </div>
            <div className="flex justify-end">
                <div className="m-1">
                    <Button
                        id="add"
                        type={"red"}
                        action={() => {
                            closeModal();
                        }}
                        name={
                            <svg
                                width="24px"
                                height="24px"
                                viewBox="0 0 24 24"
                                onClick={() => _delete()}
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M5.12817 8.15391C5.12817 10.4103 5.12817 13.5898 5.12817 15.1283C5.23074 16.4616 5.3333 18.2052 5.43587 19.436C5.53843 20.8719 6.7692 22.0001 8.2051 22.0001H15.7948C17.2307 22.0001 18.4615 20.8719 18.5641 19.436C18.6666 18.2052 18.7692 16.4616 18.8718 15.1283C18.9743 13.5898 18.8718 10.4103 18.8718 8.15391H5.12817Z"
                                    fill="#FFFFFF"
                                />
                                <path
                                    d="M19.1795 5.07698H16.6154L15.7949 3.53852C15.2821 2.61545 14.359 2.00006 13.3333 2.00006H10.8718C9.84615 2.00006 8.82051 2.61545 8.41026 3.53852L7.38462 5.07698H4.82051C4.41026 5.07698 4 5.48724 4 5.8975C4 6.30775 4.41026 6.71801 4.82051 6.71801H19.1795C19.5897 6.71801 20 6.41032 20 5.8975C20 5.38468 19.5897 5.07698 19.1795 5.07698ZM9.12821 5.07698L9.64103 4.25647C9.84615 3.84621 10.2564 3.53852 10.7692 3.53852H13.2308C13.7436 3.53852 14.1538 3.74365 14.359 4.25647L14.8718 5.07698H9.12821Z"
                                    fill="#FFFFFF"
                                />
                            </svg>
                        }
                    />
                </div>
                <div className="m-1">
                    <Button
                        id="add"
                        type={"empty"}
                        action={() => {
                            closeModal();
                        }}
                        name="Annuler"
                    />
                </div>

                <div className="m-1">
                    <Button id="add" action={() => _edit()} name={"Modifier"} loading={isSaving} />
                </div>
            </div>
        </>
    );
};
export const BadgeusesTab = (props) => {
    const { currentApp, currentMenu, currentTab, user } = props;
    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["COMPANY"]["features"];

    const navigate = useNavigate();

    const [data, setData] = useState([]);
    const [openSideBar, setOpenSidebar] = useState(false);
    const [sideBarTitle, setSidebarTitle] = useState("");
    const [sideBarContent, setSidebarContent] = useState("");
    const headers = ["Intitulé", "Type de Badgeuse", "Notes"];

    const { establishment_id } = useParams();

    const typeLabel = {
        PHYSICAL: {
            label: "Physique",
        },
        WEB: {
            label: "Internet",
        },
        MOBILE: {
            label: "Mobile",
        },
    }

    const loadBadgeuses = async () => {
        await getBadgeusesEstablishments(establishment_id).then((resp) => {
            setData(
                resp.data.map((resp) => {
                    return {
                        row: [resp.name, typeLabel[resp.type].label, resp.remarks ?? ""],
                        data: resp,
                    };
                })
            );
        });
    };
    const rowClick = (value) => {
        setSidebarTitle("Badgeuse");
        setSidebarContent(
            <BadgeusesForm
                badgeuse={value}
                closeModal={() => setOpenSidebar(false)}
                refreshData={loadBadgeuses}
            />
        );
        setOpenSidebar(true);
        navigate(value.id);
    };

    useEffect(() => {
        loadBadgeuses();
    }, [establishment_id]);

    return (
        <div className="mb-10">
            <Table
                name={"Badgeuse[s]"}
                addNavigate={
                    "/company/establishments/" +
                    establishment_id +
                    "/badgeuse/new"
                }
                isVisible={features_right['add_pointing_device']}
                headers={headers}
                rows={data}
                onClick={rowClick}
            />
            <SideBar
                title={sideBarTitle}
                content={sideBarContent}
                isOpen={openSideBar}
                onClose={() => {
                    setOpenSidebar(false);
                }}
            />
        </div>
    );
};
